// extracted by mini-css-extract-plugin
export default {"inputAndLabel":"styles_inputAndLabel__Bdyw6","label":"styles_label__SKG-t","input":"styles_input__69m-U","textEditor":"styles_textEditor__PJiRo"};